// src/i18n/en/lockers.js
const lockers = {
    name: 'Locker |||| Lockers',
    title: 'Locker Management',
    titles: {
        list: 'Lockers',
        create: 'New Locker',
        edit: 'Edit Locker',
        show: 'Locker Details',
    },
    fields: {
        id: 'ID',
        displayNumber: 'N.',
        display_number: 'N.',
        hardwareId: 'ID',
        hardware_id: 'ID',
        lockerController: 'Controller',
        controller: 'Controller',
        hotel: 'Hotel',
        hotelId: 'Hotel',
        hotel_id: 'Hotel',
        zone: 'Zone',
        zoneId: 'Zone',
        zone_id: 'Zone',
        lockerType: 'Type',
        locker_type: 'Locker Type',
        lockerTypeId: 'Type',
        status: 'Status',
        statusReason: 'Status Reason',
        status_reason: 'Status Reason',
        assignment: 'Assignment',
        assignmentId: 'Assignment',
        assignment_id: 'Assignment ID',
        assignedAt: 'Assigned on',
        assigned_at: 'Assignment Date',
        reservedUntil: 'Reserved until',
        lastMaintenance: 'Last maintenance',
        last_maintenance_at: 'Last Maintenance',
        notes: 'Notes',
        blockReason: 'Block Reason',
        releaseReason: 'Reason',
        isActive: 'Active',
        createdAt: 'Created',
        updatedAt: 'Updated',
    },
    status: {
        available: 'Available',
        occupied: 'Occupied',
        maintenance: 'Maintenance',
        outOfService: 'Out of service',
        out_of_service: 'Out of Service',
        reserved: 'Reserved',
        blocked: 'Blocked',
    },
    filters: {
        title: 'Filters',
        search: 'Search by number or ID...',
        search_placeholder: 'Search lockers...',
        status: 'Status',
        all_status: 'All statuses',
        zone: 'Zone',
        all_zones: 'All zones',
        type: 'Type',
        all_types: 'All types',
        hotel: 'Hotel',
        all_hotels: 'All hotels',
        available_only: 'Only available',
        occupied_only: 'Only occupied',
        maintenance_only: 'Under maintenance',
        assignment: 'Assignment',
        with_assignment: 'With assignment',
        without_assignment: 'Without assignment',
    },
    actions: {
        create: 'New Locker',
        edit: 'Edit',
        delete: 'Delete',
        assign: 'Assign',
        release: 'Release',
        maintenance: 'Maintenance',
        activate: 'Activate',
        deactivate: 'Deactivate',
        view_details: 'View details',
        view_history: 'View history',
        bulk_assign: 'Assign multiple',
        bulk_release: 'Release multiple',
        export: 'Export lockers',
        import: 'Import lockers',
        block: 'Block',
        unblock: 'Unblock',
        force_release: 'Force release',
    },
    placeholders: {
        block_reason: 'e.g: Door broken, needs maintenance',
        release_reason: 'e.g: Guest left without checking out'
    },
    validation: {
        minLength: 'Minimum {{min}} characters',
        maxLength: 'Maximum {{max}} characters',
        positive: 'Must be a positive number'
    },
    help: {
        title: 'Lockers',
        description: 'Manage the physical lockers in the system.',
        feature_management: 'Individual and batch locker management',
        feature_status: 'Status control: available, occupied, reserved, or blocked',
        feature_zones: 'Organization by zones within the hotel',
        feature_controllers: 'Association with hardware controllers',
        displayNumber: 'Visible locker number',
        hardwareId: 'Unique hardware identifier',
        notes: 'Additional observations about the locker',
    },
    sections: {
        basic_info: 'Basic Information',
        basic_info_subtitle: 'Main locker data',
        info: 'Additional information',
        create: 'Create Locker',
        create_subtitle: 'Enter the new locker details'
    },
    warnings: {
        occupied_edit: 'This locker is occupied. Some fields cannot be modified while in use.'
    },
    errors: {
        update: 'Error updating locker'
    },
    messages: {
        block_reason_required: 'You must indicate a reason to block the locker',
        block_reason_too_short: 'The reason must be at least 5 characters long',
        block_success: 'Locker %{displayNumber} blocked successfully',
        block_error: 'Error blocking locker',
        unblock_success: 'Locker %{displayNumber} unblocked successfully',
        unblock_error: 'Error unblocking locker',
        force_release_success: 'Locker %{displayNumber} released successfully',
        force_release_error: 'Error releasing locker'
    },
    dialogs: {
        delete_title: 'Delete Locker',
        delete_message: 'Are you sure you want to delete locker {{displayNumber}}?',
        delete_warning: 'This action cannot be undone. The locker will be marked as inactive.',
        block_title: 'Block locker %{displayNumber}',
        force_release_title: 'Force release locker %{displayNumber}'
    },
    batch: {
        title: 'Batch Create Lockers',
        subtitle: 'Create multiple lockers with consecutive numbering',
        mode_label: 'Creation mode',
        mode_single: 'Single locker',
        mode_batch: 'Multiple lockers',
        numbering: 'Numbering',
        prefix: 'Prefix',
        prefix_help: 'Optional. E.g.: A, B, ZONE1',
        start_number: 'Start number',
        end_number: 'End number',
        end_must_be_greater: 'Must be greater than or equal to the start number',
        start_hardware_id: 'Initial hardware ID',
        start_hardware_id_help: 'Controller ID for the first locker',
        location: 'Location',
        preview: 'Preview',
        preview_subtitle: '%{count} lockers will be created',
        no_preview: 'Adjust the numbers to see the preview',
        more: 'more',
        large_batch_warning: 'You are about to create %{count} lockers. This operation may take a moment.',
        notes_placeholder: 'Optional notes for all lockers in the batch',
        creating: 'Creating lockers...',
        created: 'created',
        failed: 'failed',
        create_button: 'Create %{count} lockers',
        success: '%{count} lockers created successfully',
        partial_success: '%{created} lockers created, %{errors} with errors',
        error_no_lockers: 'No lockers to create. Adjust the numbering.',
    },
    notifications: {
        updated: 'Locker {{displayNumber}} updated successfully'
    },
    helpers: {
        block_reason: 'Specify the reason why this locker is being blocked',
        block_reason_optional: 'Optionally, specify the reason for blocking (recommended for traceability)',
        release_reason_optional: 'Optionally, specify the reason for releasing (recommended for traceability)'
    },
    assignment_info: {
        available: 'Available',
        assigned: 'Assigned',
        today: 'Today',
        yesterday: 'Yesterday',
        days_ago: '%{count} days ago',
        weeks_ago: '%{count} weeks ago',
        months_ago: '%{count} months ago',
        reference: 'Reference',
        assignment_id: 'Assignment ID',
        room: 'Room',
        guest: 'Guest',
        status: 'Status',
        assigned_at: 'Assigned',
        time_assigned: 'Time assigned',
        user: 'User',
        room_number: 'Room %{number}',
    }
};

export default lockers;
